/**
 * AutoMapa public vehicle search — copy and defaults (Milestone 3).
 */
export const AUTOMAPA_PUBLIC_VIEW_SLUG = "automap";

export const DEFAULT_SEARCH_PAGE_SIZE = 24;

/** API fetch size when ranking recommended results with dealer diversity. */
export const RECOMMENDED_SEARCH_POOL_PAGE_SIZE = 100;

export const SEARCH_LOADING_COPY = {
  primary: "Buscando vehículos…",
  secondary: "Cargando publicaciones…",
};

export const SEARCH_ERROR_COPY = {
  title: "No pudimos cargar los vehículos.",
  body: "Intenta nuevamente en unos segundos.",
  retry: "Reintentar",
};

export const SEARCH_EMPTY_COPY = {
  title: "No encontramos vehículos con estos filtros.",
  body: "Prueba ampliar tu búsqueda o quitar algunos filtros.",
  cityHint: "También puedes buscar en toda Colombia o usar el asistente de compra para recibir recomendaciones.",
  resetFilters: "Limpiar filtros",
  viewAllVehicles: "Ver todos los vehículos",
  checklistCta: "Ver checklist de compra",
  quizCta: "Usar asistente de compra",
  dealerDirectoryCta: "Explorar concesionarios",
};

export const SEARCH_PAGINATION_COPY = {
  loadMore: "Cargar más vehículos",
  end: "Ya viste todos los resultados disponibles",
  showing: (visible, total) =>
    total != null && total > 0 ? `Mostrando ${visible} de ${total}` : null,
};
